import axios, { API_URL } from '../../services/axios';
import { EnquiryGroup } from '../../types/enquiries';
import { AppThunk } from '../store';
import { setData, setMoreData, setLoading, setError } from './enquiries.slice';

const PAGE_SIZE = 10;

type DefaultThunk = (imageLocator?: string) => AppThunk;

type NewEnquiry = (params: EnquiryParams, imageLocator?: string) => AppThunk<Promise<boolean>>;

type GetEnquiry = (propertyId: number) => AppThunk<Promise<EnquiryGroup>>;

interface EnquiryCustomData {
  'Property Type': string;
  'Approximate Budget Range': string;
  'Are you approved for a mortgage?': string;
  'Do you have a property to sell?': string;
}

interface EnquiryParams {
  propertyId: number;
  propertyType: string;
  contact: string;
  name: string;
  email: string;
  tel: string;
  comments: string;
  recaptcha?: string;
  customData?: EnquiryCustomData;
}

export const getEnquiries: DefaultThunk = (imageLocator) => async (dispatch) => {
  dispatch(setLoading(true));

  try {
    const result = await axios(
      {
        method: 'GET',
        url: `${API_URL}/enquiry-group?page=0&pageSize=${PAGE_SIZE}`,
        params: {
          imageLocator,
        },
      },
      dispatch,
    );

    dispatch(setData(result.data));
  } catch (err: any) {
    dispatch(setError(err));
  } finally {
    dispatch(setLoading(false));
  }
};

export const getMoreEnquiries: DefaultThunk = (imageLocator) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  const { enquiries } = getState();

  try {
    const result = await axios(
      {
        method: 'GET',
        url: `${API_URL}/enquiry-group?page=${enquiries.page + 1}&pageSize=${PAGE_SIZE}`,
        params: {
          imageLocator,
        },
      },
      dispatch,
    );

    dispatch(setMoreData(result.data));
  } catch (err: any) {
    dispatch(setError(err));
  } finally {
    dispatch(setLoading(false));
  }
};

export const newEnquiryRecaptcha: NewEnquiry = (params, imageLocator) => async (dispatch, getState) => {
  const { user } = getState();
  const { propertyId, propertyType, ...data } = params;

  try {
    await axios(
      {
        method: 'POST',
        url: `${API_URL}/${propertyType}/${propertyId}/enquiry-with-recaptcha`,
        data,
      },
      dispatch,
    );

    if (user.loggedIn) {
      dispatch(getEnquiries(imageLocator));
    }

    return true;
  } catch {
    return false;
  }
};

export const newEnquiry: NewEnquiry = (params, imageLocator) => async (dispatch, getState) => {
  const { user } = getState();
  const { propertyId, propertyType, ...data } = params;

  try {
    await axios(
      {
        method: 'POST',
        url: `${API_URL}/${propertyType}/${propertyId}/enquiry`,
        data,
      },
      dispatch,
    );

    if (user.loggedIn) {
      dispatch(getEnquiries(imageLocator));
    }

    return true;
  } catch {
    return false;
  }
};

export const getEnquiry: GetEnquiry = (propertyId) => async (dispatch) => {
  try {
    const result = await axios(
      {
        method: 'GET',
        url: `${API_URL}/enquiry-group/${propertyId}`,
      },
      dispatch,
    );

    return result?.data;
  } catch {
    return false;
  }
};
